import moment from 'moment';

let localActiveOutlet = localStorage.getItem('active_outlet');
let localStartDate = localStorage.getItem('start_date');
let localEndDate = localStorage.getItem('end_date');

main();

const state = {
    activeOutlet:
        localActiveOutlet == null || localActiveOutlet == 'null'
            ? null
            : localActiveOutlet,
    startDate: localStartDate
        ? moment(localStartDate)
        : moment().startOf('day'),
    endDate: localEndDate ? moment(localEndDate) : moment().endOf('day'),
};

const getters = {
    activeOutlet(state) {
        return state.activeOutlet;
    },

    startDate(state) {
        return state.startDate;
    },

    endDate(state) {
        return state.endDate;
    },
};

const mutations = {
    setDateFilterRange(state, range) {
        state.startDate = range.start;
        state.endDate = range.end;

        localStorage.setItem(
            'start_date',
            range.start ? range.start.toISOString() : null,
        );
        localStorage.setItem(
            'end_date',
            range.end ? range.end.toISOString() : null,
        );
    },

    setActiveAllOutlets(state) {
        this.setActiveOutlet(state, 0);
    },

    setActiveOutlet(state, id) {
        state.activeOutlet = id;
        localStorage.setItem('active_outlet', id);
    },

    resetDateFilterRange(state) {
        state.startDate = null;
        state.endDate = null;
        localStorage.removeItem('start_date');
        localStorage.removeItem('end_date');
    },
};

function main() {
    if (shouldClearLocalStorage()) {
        clearLocalStorage();
    }

    setLastActive();
}

function shouldClearLocalStorage() {
    let lastActive = getLastActive();

    if (lastActive != null) {
        let now = moment();
        return now.diff(lastActive, 'minutes') > 5;
    }

    return false;
}

function getLastActive() {
    let lastActive = localStorage.getItem('last_active');

    if (lastActive != null) {
        return moment(lastActive);
    }

    return null;
}

function setLastActive() {
    localStorage.setItem('last_active', moment().toISOString());
}

function clearLocalStorage() {
    localStorage.removeItem('start_date');
    localStorage.removeItem('end_date');
    localStorage.removeItem('active_outlet');
}

export default {
    state,
    getters,
    mutations,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/outlet-date-filters.js